import { SVGProps } from 'react';

export function Other(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      {...props}
    >
      <rect
        width='24'
        height='24'
        rx='2'
        fill='#E0F7FC'
      />
      <path
        d='M5.33334 18.6665H18.6667'
        stroke='#00BFDE'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.0067 18.6599L6.00667 18.6732L6 8.71324C6 8.26657 6.22668 7.85322 6.59334 7.60655L9.26001 5.82656C9.70668 5.52656 10.2933 5.52656 10.74 5.82656L13.4067 7.60655C13.78 7.85322 14 8.26657 14 8.71324L14.0067 18.6599Z'
        stroke='#00BFDE'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.32 18.6733V16'
        stroke='#00BFDE'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.3333 12C16.6 12 16 12.6 16 13.3333V14.6667C16 15.4 16.6 16 17.3333 16C18.0667 16 18.6667 15.4 18.6667 14.6667V13.3333C18.6667 12.6 18.0667 12 17.3333 12Z'
        stroke='#00BFDE'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6 13.3335H14'
        stroke='#00BFDE'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10 18.6665V16.1665'
        stroke='#00BFDE'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10 11C10.5523 11 11 10.5523 11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11Z'
        stroke='#00BFDE'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
